/** 海仓帮助中心（独立站点）登录入口 */
export const HELP_CENTER_LOGIN_URL = "https://help.seacang.com/login";

/** 首页 Hero 背景图（内页可复用） */
export const HERO_BG_IMAGE = require("@/static/official/hero-bg.jpg");
